import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import type {WebSourcesSkeletonProps} from './web-sources-skeleton.types';
import {WebSourcesSkeleton} from './web-sources-skeleton';

export const webReadSkeletonRegistration = defineStreamComponentRegistration(
  StreamComponentType.WEB_READ_SKELETON,
  WebSourcesSkeleton,
  (): WebSourcesSkeletonProps => ({variant: 'read'})
);
